import { Box, useScrollTrigger, Zoom } from "@mui/material";
import FlowTopButton from "../AppButtons/FlowTopButton";
import { useTranslation } from "../../../explorer/hooks/useTranslation";
import UtilsFunctions from "../../../explorer/utils/UtilsFunctions";
import { useScrollTopClasses } from "./ScrollTop.styles";

interface Props {
  scrollItemRef?: any;
  punchy?: boolean;
}

function ScrollTop(props: Props) {
  const { scrollItemRef, punchy } = props;

  const trigger = useScrollTrigger({
    target:
      scrollItemRef && scrollItemRef.current
        ? scrollItemRef.current
        : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event: any) => {
    UtilsFunctions.scrollTo(scrollItemRef.current, 0, 100, punchy);
  };

  const { t } = useTranslation();
  const classes = useScrollTopClasses();
  return (
    <Zoom in={trigger}>
      <Box role="presentation" sx={classes.root}>
        <FlowTopButton
          color="primary"
          sx={classes.buttonUp}
          onClick={handleClick}
        />
      </Box>
    </Zoom>
  );
}

export default ScrollTop;
